function cleanSwRegistration() {
  console.log('serviceWorker', navigator.serviceWorker);
  return new Promise((resolve, reject) =>
    navigator.serviceWorker
      .getRegistrations()
      .then((registrations: ServiceWorkerRegistration[]): void => {
        console.log('registrations', registrations);
        if (registrations.length === 0)
          resolve({
            message: 'Aucune registrations',
            content: registrations
          });
        registrations.forEach((reg, i) => {
          reg
            .unregister()
            .then(res =>
              resolve({
                message: 'Registrations Unregister avec succès',
                content: res
              })
            )
            .catch(err => reject(err));
          if (i + 1 === registrations.length) {
            resolve({
              message: 'Registrations vidé',
              content: registrations
            });
          }
        });
      })
      .catch(e => {
        reject(e);
      })
  );
}

function cleanCaches() {
  return new Promise((resolve, reject) => {
    caches
      .keys()
      .then(cacheNames => {
        if (cacheNames.length === 0)
          resolve({ message: 'Cache vide', content: cacheNames });
        cacheNames.forEach((cacheName, i) => {
          caches.delete(cacheName);
          if (i + 1 === cacheNames.length) {
            resolve({
              message: 'Le cache a été vidé avec succès',
              content: cacheNames
            });
          }
        });
      })
      .catch(e => {
        reject(e);
      });
  });
}

function cleanAll() {
  return new Promise((resolve, reject) => {
    indexedDB.deleteDatabase('workbox-expiration');
    cleanCaches()
      .then(() => {
        console.log('Cache Cleaned');
        cleanSwRegistration()
          .then(response => {
            console.log('Reg Cleaned');
            resolve(response);
          })
          .catch(e => reject(e));
      })
      .catch(e => reject(e));
  });
}

export default cleanAll;
